import React, { Component } from 'react';
import { debounce } from 'lodash';
import { Col, Collapse, Row } from 'reactstrap';
import CaretToggle from '../Icons/CaretToggle';
import ListFunctions from '../FunctionsList';
import WmReactTableServerSide from '../Layout/WmReactTableServerSide';
import Help from '../HtmlHelpers';
export default class ToggleTable extends Component {
  constructor(props) {
    super(props);
    this.canPollData = () => false;
    this.pollIntervalTime = () => 60000;
    this.getIntervalData = () => {
      if (this.canPollData()) {
        setInterval(debounce(this.getData, 500), this.pollIntervalTime());
      }
    };
    this.getTableTitle = () => {};
    this.getColumns = () => {};
    this.getDefaultParams = () => {};
    this.getStorageName = () => {};
    this.getHeader = () => /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 6,
      sm: 12
    }, this.getTableTitle()), /*#__PURE__*/React.createElement(Col, {
      md: 6,
      sm: 12,
      className: "text-right"
    }, "Data Loaded: \xA0", Help.format_utc_date_time(this.state.dataAsOf)));
    this.getUnderHeader = () => '';
    this.getContent = () => /*#__PURE__*/React.createElement("div", null, this.getHeader(), this.getUnderHeader(), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.isOpen
    }, this.getTable(), this.additionalContent()));
    this.additionalContent = () => '';
    this.getData = async () => {
      const now = new Date();
      const data = await ListFunctions.fetchData(this.getDefaultParams());
      data.dataAsOf = now;
      this.setState(data);
    };
    this.getTableClassSettings = () => '';
    this.getTrProps = (state, rowInfo, instance) => ({});
    this.getTable = () => /*#__PURE__*/React.createElement(WmReactTableServerSide, {
      ref: this.tableRef,
      innerRef: this.innerTableRef,
      className: this.getTableClassSettings(),
      pages: this.state.pages,
      data: this.state.data,
      loading: this.state.loading,
      columns: this.getColumns(),
      onFetchData: debounce(this.getData, 500),
      filtered: ListFunctions.getFiltered(this.getStorageName()),
      onFilteredChange: filtered => this.setState(ListFunctions.onFilteredChange(this.getStorageName(), filtered)),
      sorted: ListFunctions.getSorted(this.getStorageName()),
      onSortChange: sorted => ListFunctions.onSortChange(this.getStorageName(), sorted),
      resetFilters: this.hideReset() ? undefined : () => ListFunctions.resetFilters(this.getStorageName(), this.tableRef),
      getTrProps: this.getTrProps,
      noDataText: this.state.apiListErrors
    });
    this.canCollapse = () => true;
    this.caretToggle = () => {
      const data = this.state.data || [];
      return /*#__PURE__*/React.createElement("span", null, "\xA0\xA0\xA0", /*#__PURE__*/React.createElement(CaretToggle, {
        onClick: this.toggle,
        open: this.state.isOpen
      }));
    };
    this.hideReset = () => false;
    this.toggle = () => this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
    this.state = {
      isOpen: true,
      loading: true,
      data: [],
      dataAsOf: null
    };
    this.tableRef = React.createRef();
    this.innerTableRef = React.createRef();
  }
  render() {
    return this.getContent();
  }
}